import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import draggable from "vuedraggable";
import settingSlot from "./settingSlot";
import iconSelect from "../pages/page-components/iconSelect.vue";
import bgColorSelect from "../pages/page-components/bgColorSelect";
import MaterialList from '@/components/material/list.vue';
import { getPage as _getPage, getObj, addObj, putObj, delObj } from '@/api/mall/bargaininfo';
import { tableOption2 } from '@/const/crud/mall/bargaininfo';
export default {
  components: {
    draggable: draggable,
    settingSlot: settingSlot,
    iconSelect: iconSelect,
    bgColorSelect: bgColorSelect,
    MaterialList: MaterialList
  },
  data: function data() {
    return {
      dialogVisibleGoods: false,
      shopList: [],
      selectionGoodsSpu: [],
      form2: {},
      tableData2: [],
      page2: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 20,
        // 每页显示多少条
        ascs: [],
        //升序字段
        descs: [] //降序字段
      },

      paramsSearch2: {},
      tableLoading2: false,
      tableOption2: tableOption2,
      formDataCopy: {
        background: 'bg-gradual-scarlet',
        backgroundImg: '',
        titleImage: '',
        title: '全民砍价',
        titleColor: '#FFFFFF',
        subtitle: '呼朋唤友，疯狂砍价',
        subtitleColor: '#FFFFFF',
        titleIcon: 'cuIcon-message',
        pageSpacing: 0,
        goodsList: []
      },
      formData: {}
    };
  },
  props: {
    shopId: {
      type: String
    },
    showData: {
      type: Object,
      default: function _default() {}
    },
    config: {
      type: Object,
      default: function _default() {}
    },
    thememobile: {
      type: Object | Array
    }
  },
  computed: _objectSpread({}, mapState({
    componentsList: function componentsList(state) {
      return state.divpageShop.componentsList;
    },
    clickComIndex: function clickComIndex(state) {
      return state.divpageShop.clickComIndex;
    }
  })),
  mounted: function mounted() {
    var that = this;
    if (that.IsEmptyObj(that.showData)) {
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
    } else {
      that.formData = that.showData;
    }
    that.$set(that.componentsList[that.clickComIndex], 'data', this.formData);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(['updateData'])), {}, {
    addItem: function addItem() {
      var that = this;
      that.pushItem();
    },
    pushItem: function pushItem() {
      var that = this;
      // if(that.formData.goodsList&&that.formData.goodsList.length >=10){
      //   that.$message.error("项目不能超过10条")
      //   return false;
      // }
      this.formData.goodsList.push({
        id: Math.random(),
        picUrls: [],
        name: '商品名',
        sellPoint: '',
        pointsGiveSwitch: '',
        freightTemplat: {},
        saleNum: 0,
        priceDown: ''
      });
    },
    // 删除项目
    delItem: function delItem(index) {
      var that = this;
      if (that.formData.goodsList.length <= 1) {
        that.$message.error("请至少保留一条项目");
        return false;
      }
      that.$confirm('是否删除该项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.formData.goodsList, index);
      }).catch(function () {});
    },
    // 删除按钮
    delBtn: function delBtn(index) {
      var that = this;
      that.$confirm('是否删除该组件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.componentsList[that.clickComIndex].data.itemArray, index);
        that.updateData({
          componentsList: that.componentsList
        });
      }).catch(function () {});
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    reset: function reset() {
      var that = this;
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
      that.componentsList[that.clickComIndex]['data'] = this.formData;
    },
    confirm: function confirm() {
      this.$emit('confirm', this.formData);
    },
    delete: function _delete() {
      this.$emit('delete');
    },
    getPage2: function getPage2(page, params) {
      var _this = this;
      this.tableLoading2 = true;
      this.paramsSearch2.shopId = this.shopId;
      _getPage(Object.assign({
        current: page.currentPage,
        size: page.pageSize,
        descs: this.page2.descs,
        ascs: this.page2.ascs
      }, params, this.paramsSearch2)).then(function (response) {
        var tableData = response.data.data.records;
        _this.tableData2 = tableData;
        _this.page2.total = response.data.data.total;
        _this.page2.currentPage = page.currentPage;
        _this.page2.pageSize = page.pageSize;
        _this.tableLoading2 = false;
        // 加载列表级联数据
        _this.$nextTick(function () {
          _this.$refs.crud.dicInit('cascader');
        });
      }).catch(function () {
        _this.tableLoading2 = false;
      });
    },
    searchChange2: function searchChange2(params, done) {
      params = this.filterForm(params);
      this.paramsSearch2 = params;
      this.page2.currentPage = 1;
      this.getPage2(this.page2, params);
      done();
    },
    refreshChange2: function refreshChange2(val) {
      this.getPage2(val.page);
    },
    sortChange2: function sortChange2(val) {
      var prop = val.prop ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase() : '';
      if (val.order == 'ascending') {
        this.page2.descs = [];
        this.page2.ascs = prop;
      } else if (val.order == 'descending') {
        this.page2.ascs = [];
        this.page2.descs = prop;
      } else {
        this.page2.ascs = [];
        this.page2.descs = [];
      }
      this.getPage(this.page);
    },
    selectionChange2: function selectionChange2(list) {
      this.selectionGoodsSpu = list;
    },
    showGoodsList: function showGoodsList() {
      this.tableData2 = [];
      this.dialogVisibleGoods = true;
      this.getPage2(this.page2);
    },
    subGoods: function subGoods() {
      this.formData.goodsList = [].concat(_toConsumableArray(this.selectionGoodsSpu), _toConsumableArray(this.formData.goodsList));
      var that = this;
      that.$set(that.componentsList[that.clickComIndex], 'data', this.formData);
      that.updateData({
        componentsList: that.componentsList
      });
      this.dialogVisibleGoods = false;
    }
  }),
  watch: {
    showData: {
      handler: function handler(newVal, oldVal) {
        this.formData = newVal ? newVal : this.formData;
      },
      deep: true
    }
  }
};